<template>
    <div class="modules-content" v-click-outside="onClickOutside">
        <div class="modules-content-head">
            <div class="modules-content-head-title">
                {{ $t("modules.modules") }}
                <a-icon type="setting" class="settings-icon" @click.stop="gotoModuleSettings" />
            </div>
        </div>
        <div class="modules-content-body">
            <div class="modules-content-item" v-for="module of modules" :key="module._id" @click="gotoModule(module)">
                <div class="modules-content-item-icon">
                    <div class="material-icons">{{ module.icon || "extension" }}</div>
                </div>
                <div class="modules-content-item-title" v-tippy="{ content: module.displayName }">
                    <span class="ellipsis">{{ module.displayName }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { log2 } from "../utils/log2";
import SupsisButton from "../views/Pages/Settings/components/SupsisButton.vue";

const log = log2("ModulesDropdown");
export default {
    name: "ModulesDropdown",
    components: {
        SupsisButton,
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
    },
    directives: {
        "click-outside": {
            bind(el, binding) {
                el.clickOutsideEvent = function (event) {
                    if (!(el === event.target || el.contains(event.target))) {
                        binding.value(event);
                    }
                };
                document.addEventListener("click", el.clickOutsideEvent);
            },
            unbind(el) {
                document.removeEventListener("click", el.clickOutsideEvent);
            },
        },
    },
    computed: {
        ...mapState({
            modules: (state) =>
                state.module.modules.filter((module) => module.type === "module" && module.settings.showInMainMenu),
        }),
        ...mapGetters({
            isLoggedIn: "auth/isLoggedIn",
            getWaitingTickets: "ticket/getWaitingTickets",
        }),
    },
    methods: {
        gotoModule(module) {
            this.$emit("selected");
            this.$router.push(`/module/${module.moduleName}`);
        },
        onClickOutside() {
            //this.$emit("close");
        },
        gotoModuleSettings() {
            this.$emit("selected");
            this.$router.push("/tables?type=modules");
        },
    },
};
</script>

<style lang="scss" scoped>
.modules-content-head {
    &-title {
        display: flex;
        align-items: center;
         white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        gap: 8px;

        .settings-icon {
            font-size: 16px;
            cursor: pointer;
            color: rgba(0, 0, 0, 0.65);

            &:hover {
                color: #1890ff;
            }
        }
    }
}

.modules-content-item-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block; /* veya inline-block */
    max-width: 100px; /* Genişliği daha da daraltın */
}

.ellipsis {
    display: block; /* veya inline-block */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
